// cspell:ignore lngs

import type { FlatNamespace, InitOptions } from 'i18next'

import { type LanguageId, LanguageIds } from '@mntn-dev/domain-types'

import { defaultNS, fallbackLanguageId } from './settings.ts'

export function getOptions(
  lng: LanguageId = fallbackLanguageId,
  ns: FlatNamespace = defaultNS,
  languageIds: LanguageId[] = [...LanguageIds],
  defNS: FlatNamespace = defaultNS,
  defLanguageId: LanguageId = fallbackLanguageId,
  escapeSpecialCharacters: boolean = true
): InitOptions {
  return {
    supportedLngs: languageIds,
    fallbackLng: defLanguageId,
    lng,
    fallbackNS: defNS,
    defaultNS: defNS,
    ns,
    interpolation: { escapeValue: escapeSpecialCharacters },
    /**
     * As of version 21.3.0, i18next has built in number formatting based on Intl API.
     * See: https://www.i18next.com/translation-function/formatting
     */
  }
}
